import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SvgIcon } from '@mui/material';
export function InfobaseIconSG(props) {
    //  Extract props
    let { styles } = props;
    if (!styles) {
        // If styles is undefined, initilize it as an empty object
        styles = {};
    }
    return (_jsx(SvgIcon, Object.assign({ sx: Object.assign({ fontSize: '24px' }, styles), viewBox: '0 0 24 24' }, { children: _jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("g", Object.assign({ id: "Icon" }, { children: _jsx("path", { id: "Vector", d: "M11 21V14.4L6.35 19.075L4.925 17.65L9.6 13H3V11H9.6L4.925 6.35L6.35 4.925L11 9.6V3H13V9.6L17.65 4.925L19.075 6.35L14.4 11H21V13H14.4L19.075 17.65L17.65 19.075L13 14.4V21H11Z", fill: 'currentColor' }) })) })) })));
}
